import { useState, useEffect } from 'react';

const Loading = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        const loadingFn = e => {
            const curLoading = e.detail.loading;
            if (curLoading === false) {
                setTimeout(() => {
                    setLoading(curLoading);
                }, 500);
            } else {
                setLoading(curLoading);
            }
        }

        window.document.addEventListener('loading', loadingFn);

        return () => {
            window.document.removeEventListener('loading', loadingFn);
        }

    }, []);    

    if (!loading) {
        return null;
    }

    return (
        <div class="loading-overlay">
            <div class="loading-spinner"></div>
        </div>
    )
}

export default Loading;